export const baseURL = "https://appscheduling-rest-dev.ventuso.net";
export const key = "b9946ea66c9ac397b76a8623ad10bbf7";